import styled, { css } from 'styled-components'

interface ILabelProps {
  isRequired?: boolean
  isInvalid?: boolean
}

export const Label = styled.span<ILabelProps>`
  font-size: 14px;
  font-weight: 500
    ${({ theme, isRequired = false, isInvalid = false }) => css`
      color: ${isRequired || isInvalid
        ? theme.colors.textError
        : theme.colors.text};
    `};
`

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 3px;
  margin-top: 4px;
  margin-bottom: 4px;
`
